const FETCH_COURSE_LIST_START = 'FETCH_COURSE_LIST_START'
const FETCH_COURSE_LIST_DATA = 'FETCH_COURSE_LIST_DATA'

export {
  FETCH_COURSE_LIST_START,
  FETCH_COURSE_LIST_DATA,
}
